import { z } from "zod"

import { ValidationPresets } from "@/utils/validation-presets"

export const notebookRecurrenceSchema = z
  .object({
    cadence: z.enum(["daily", "weekly", "monthly"]),
    interval: z.number().int().min(1).max(365),
    time: z.string().regex(/^(?:[01]\d|2[0-3]):[0-5]\d$/),
    timezone: z.string().max(100).pipe(ValidationPresets.strings.timezone),
  })
  .strict()

export type NotebookRecurrence = z.infer<typeof notebookRecurrenceSchema>
